import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-processbar',
  templateUrl: './ui-processbar.component.html',
  styleUrls: ['./ui-processbar.component.scss']
})
export class UiProcessbarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
